module.exports = __webpack_public_path__ + "static/media/builtinv2-Ubiquiti_Netwos.af05cb85.png";